@if (group) {
  <ng-container [formGroup]="group">
    <ng-container *ngTemplateOutlet="formField"></ng-container>
  </ng-container>
}

@if (!group) {
  <ng-container *ngTemplateOutlet="formField"></ng-container>
}

<ng-template #formField>
  <div class="container">
    @if (!hideIconSpace) {
      <mat-icon [ngClass]="{ focus: input.focused }">{{ icon }}</mat-icon>
    }
    <mat-form-field color="accent" [ngClass]="{ 'retain-default-disabled': retainDefaultDisabled }">
      @if (!removeLabelCasePipe) {
        <mat-label>{{ label | titlecase }}</mat-label>
      }
      @if (removeLabelCasePipe) {
        <mat-label>{{ label }}</mat-label>
      }
      <input
        matInput
        #input="matInput"
        [type]="inputType"
        [formControl]="control"
        [attr.aria-label]="ariaLabel || null"
        [attr.autocomplete]="autocomplete"
        (change)="onEmitInputChange($event)"/>
      <mat-hint [ngClass]="{ highlight: isHintHighlighted, warn: isHintWarning }">{{ hint }}</mat-hint>
      @if (control.errors?.msError) {
        <mat-error>{{ control.errors?.msError == msErrorKey ? customMsError : control.errors?.msError }}</mat-error>
      }
      @if (control.errors?.required) {
        <mat-error>{{ customRequiredMessage != null ? customRequiredMessage : sysText.required | capitalizefirst }}</mat-error>
      }
      @if (control.errors?.min) {
        <mat-error>{{ sysText.invalidMinValueError | capitalizefirst }} {{ control.errors.min.min }}</mat-error>
      }
      @if (control.errors?.minlength) {
        <mat-error>{{ sysText.invalidMinLengthError | capitalizefirst }} {{ control.errors.minlength.requiredLength }}</mat-error>
      }
      @if (control.errors?.pattern) {
        <mat-error>{{ patternError }}</mat-error>
      }
    </mat-form-field>
    @if (info) {
      <!-- a button so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="sysText.moreInformation_ariaLabel"
        [matTooltip]="info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    }
  </div>
</ng-template>
